export const filtredAnalysisAuthorIds = [
  '1472fcae-9f95-42a7-b5a7-310a3444b4a2', // api santiment
  'd911f762-0024-499f-9052-2df102b0346c',
  '055f8291-6241-4fc3-8c2b-017eb3ac3acf',
  '240256cb-75d7-4fa3-9c10-ced0e13bdd39',
  'ff4efe4d-cb51-4df6-90bd-26f068df69c7',
  'b9aefbb9-ab1c-4f7e-82e9-7acc45d03007',
];
